<footer>
  <div layout="row" layout-align="center center">
      <h2> &copy; {{currentYear}} Àlex Milà</h2>
      <p class="socialmediatext">
        social media icons by <a href="https://iconos8.es">Icons8</a>
      </p>
  </div>
</footer>